import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
if (!BASE || !/^https?:\/\//.test(BASE)) {
  // Fail loud at boot — better than silently posting to the wrong origin.
  // eslint-disable-next-line no-console
  console.error(
    "[Builders Binder] REACT_APP_BACKEND_URL is missing or invalid:",
    JSON.stringify(BASE),
    "— set it on Netlify and redeploy with 'Clear cache and deploy site'."
  );
}
export const API = `${BASE}/api`;

// ---------------------------------------------------------------------------
// Token helpers — localStorage fallback for mobile browsers (iOS Safari ITP,
// Android WebView) that block or partition SameSite=None cross-site cookies.
//
// The backend already accepts an Authorization: Bearer <token> header as a
// fallback when the session_token cookie is absent (see get_current_user).
// Storing the token in localStorage is safe here because:
//   1. localStorage is same-origin — it cannot be read cross-site.
//   2. The backend only uses the header if the cookie is absent, so desktop
//      browsers that handle cookies correctly are unaffected.
//   3. The token is also cleared on logout (see clearToken below).
// ---------------------------------------------------------------------------
const TOKEN_KEY = "session_token";

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};

export const setToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
};

export const clearToken = () => {
  try { localStorage.removeItem(TOKEN_KEY); } catch {}
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true, // sends the httpOnly session_token cookie on every request
});

// Attach Authorization: Bearer <token> on every request as a mobile fallback.
// Desktop browsers that already send the cookie will have the header ignored
// by the backend (it only reads it when the cookie is absent).
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch { return iso; }
};
export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch { return iso; }
};
